import { createRouter, createWebHashHistory } from 'vue-router';
import Home from '../views/Home.vue';
import About from '../views/About.vue';
import Solution from '../views/Solution.vue';
import Service from '../views/Service.vue';
import Product from '../views/Product.vue';
import SmartCloud from '../views/SmartCloud.vue';
import Cases from '../views/Cases.vue'


const routes = [
  {
    path: "/",
    component: Home
  },
  {
    path: "/About",
    component: About
  },
  {
    path: "/Product",
    component: Product,
    children: [
      {
        path: "",
        redirect: "/Product/Parking"
      },
      {
        path: "Parking",
        name: "Parking",
        component: () => import("../views/ProductChildren/Parking.vue")
      },
      {
        path: "Parking/:id",
        name: "ParkingDetail",
        component: () => import("../views/ProductChildren/ParkingDetail/ParkingDetail.vue"),
        props: true
      }

      ,
      {
        path: "Charging",
        name: "Charging",
        component: () => import("../views/ProductChildren/Charging.vue")
      },
      {
        path: "Community",
        name: "Community",
        component: () => import("../views/ProductChildren/Community.vue")
      }
    ]
  },
  {
    path: "/Solution",
    component: Solution

  },
  {
    path: "/Service",
    component: Service
  },
  {
    path: "/SmartCloud",
    component: SmartCloud
  },
  {
    path: "/Cases",
    component: Cases
  }

]

const router = createRouter(
  {
    history: createWebHashHistory(),
    routes,


  }
)

export default router;